import { SearchFormModel } from "../interface"

import { MAX_PRICE, MIN_PRICE } from "@modules/PsyProfile/common/constants"

export function buildCatalogQueryString(
    searchFormData: SearchFormModel,
    fallbackCompetences: number[]
) {
    const qs = {} as Record<string, string | number>
    if (searchFormData.city) {
        qs.city = searchFormData.city
    }

    qs.form_of_work = searchFormData.form_of_work || "any"

    if (searchFormData.price_from !== undefined && searchFormData.price_from !== MIN_PRICE) {
        qs.price_from = searchFormData.price_from
    }
    if (searchFormData.price_to !== undefined && searchFormData.price_to !== MAX_PRICE) {
        qs.price_to = searchFormData.price_to
    }
    if (fallbackCompetences.length > 0) {
        qs.competences = fallbackCompetences.join("|")
    }
    return qs
}
